import React from "react";
import { CMB_PRESENTATIONS } from "../utilities/constant";
import { PresentacionState } from "../models/PresentacionState.model";
import { Checkbox } from "primereact/checkbox";
import { PresentationFilter } from "../utilities/presentaciones.classes";
import "primeflex/primeflex.css";

interface ListChipStateProps {
  selectedStatusPre: PresentationFilter; //PresentacionState[]
  setSelectedStatusPre: (e: any) => void;
}
const ListChipState: React.FC<ListChipStateProps> = ({
  selectedStatusPre,
  setSelectedStatusPre,
}) => {
  const onItemChange = (e:any) => {
    let _selectedStatus = [...selectedStatusPre.status];

    if (e.checked) {
      _selectedStatus.push(e.value);
    } else {
      _selectedStatus = _selectedStatus.filter(
        (item) => item.id !== e.value.id
      );
    }

    setSelectedStatusPre({
      ...selectedStatusPre,
      status: [..._selectedStatus],
    });
  };
  return (
    <>
      {CMB_PRESENTATIONS.map((item: PresentacionState) => (
        <div
          key={item.id}
          className="p-d-flex p-ai-center mt-2 mr-2 p-1 pl-2 pr-2"
          style={{ backgroundColor: "#dee2e6", borderRadius: "16px" }}
        >
          <Checkbox
            className="mr-2"
            inputId={item.label}
            name="item"
            value={item}
            onChange={onItemChange}
            checked={selectedStatusPre.status.some(
              (selectedItem) => selectedItem.id === item.id
            )}
          />
          <label htmlFor={item.label} style={{ marginBottom: "initial" }}>
            {item.label}
          </label>
        </div>
      ))}
    </>
  );
};

export default ListChipState;
